import "./Dash.css"
import React from "react";
import {
  BsFillPersonVcardFill,
  BsPeopleFill,
  BsDoorOpenFill,
  BsList,
  BsHouseGearFill,
  BsCashCoin,
  BsCalendarDayFill,
  BsEnvelopeExclamationFill,
  BsBookmarksFill
} from 'react-icons/bs';
import IndianHead from "../imgs/white_indian.png"
import {FBAuth} from '../Firebase/firebase'
import {signOut} from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { useUserData } from "../Contexts/UserDataContext";

const Sidebar = ({setUserData,setUID,chosenPage,setChosenPage,sidebarStatus,setSidebarStatus}) => {
  const navigate = useNavigate()
  const {userData} = useUserData()

  const logout = async () => {
    try {
      await signOut(FBAuth)
    } catch (error) {
      console.error("Error logging out", error)
    }
    setUserData(null)
    setUID("")
    navigate("/")
  }

  const residentItems = [
    { id: 'profile', label: 'Profile', icon: BsFillPersonVcardFill },
    { id: 'payDues', label: 'Pay dues', icon: BsCashCoin },
  ]

  const adminItems = [
    { id: 'residences', label: 'Residences', icon: BsHouseGearFill },
    { id: 'residents', label: 'Residents', icon: BsPeopleFill },
    { id: 'editCalendar', label: 'Calendar', icon: BsCalendarDayFill },
    { id: 'editBanner', label: 'Homepage notice', icon: BsBookmarksFill },
    { id: 'sendAlerts', label: 'Send alert', icon: BsEnvelopeExclamationFill },
  ]

  const NavItem = ({ item }) => {
    const Icon = item.icon
    return (
      <button
        onClick={()=>setChosenPage(item.id)}
        className={`sidebar-item ${chosenPage === item.id ? 'active' : ''}`}
        aria-current={chosenPage === item.id ? 'page' : undefined}
      >
        <Icon aria-hidden="true" />
        <span className="sidebar-item-text">{item.label}</span>
      </button>
    )
  }

  return(
    <aside className={`sidebar ${sidebarStatus ? 'open' : 'closed'}`}>
      <button className="sidebar-hamburger" onClick={()=>setSidebarStatus(!sidebarStatus)} aria-label={sidebarStatus ? 'Close navigation' : 'Open navigation'}>
        <BsList/>
      </button>

      <div className="sidebar-header">
        <span className="sidebar-logo-wrap"><img className="sidebar-header-img" src={IndianHead} alt="" /></span>
        <div><strong>Indian Park</strong><small>Resident portal</small></div>
      </div>

      <nav className="sidebar-body" aria-label="Resident dashboard">
        <span className="sidebar-section-label">Your account</span>
        {residentItems.map(item => <NavItem item={item} key={item.id} />)}

        {userData?.isAdmin && (
          <>
            <span className="sidebar-section-label admin-label">Administration</span>
            {adminItems.map(item => <NavItem item={item} key={item.id} />)}
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <button onClick={logout} className="sidebar-item logout-item">
          <BsDoorOpenFill aria-hidden="true" />
          <span className="sidebar-item-text">Log out</span>
        </button>
      </div>
    </aside>
  )
}

export default Sidebar;
